import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cursor-pointer",
      attrs: { "data-qa": "club_switch" },
      on: {
        click: function ($event) {
          _setup.isEnabled = !_setup.isEnabled
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center gc-3" },
        [
          _vm.discount
            ? _c(
                "div",
                {
                  staticClass: "club-price-discount text-subtitle-2",
                  attrs: { "data-qa": "club_switch_percent" },
                },
                [
                  _vm._v("\n      -"),
                  _c("span", { attrs: { "data-qa": "club_switch_discount" } }, [
                    _vm._v(_vm._s(_vm.discount)),
                  ]),
                  _vm._v("%\n    "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-subtitle-1 error--text w-100",
              attrs: { "data-qa": "club_switch_title" },
            },
            [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c(VSwitch, {
            staticClass: "club-switch pt-0 mt-0 pl-1",
            attrs: {
              value: _setup.isEnabled,
              "input-value": _setup.isEnabled,
              color: "error",
              "data-qa": "club_switch_input",
              "hide-details": "",
              dense: "",
              inset: "",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }